/* Naht & Leinen – Startseite (Team A): Reiter (Chips), Karussell-Punkte, Beaubag-Setwahl, Video-Dialog.
   Die Karussell-Pfeile selbst steuert nl.js ([data-nl-karussell] mit [data-nl-zurueck]/[data-nl-weiter]). */
(function () {
  'use strict';
  if (window.NlHome) return;

  /* Reiter: [data-nl-home-reiter] mit role=tab-Knöpfen, die per aria-controls ihr Panel zeigen */
  function reiter(root) {
    if (root.dataset.nlHomeBereit) return;
    root.dataset.nlHomeBereit = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function waehle(tab, fokus) {
      tabs.forEach(function (t) {
        var an = t === tab;
        t.setAttribute('aria-selected', an ? 'true' : 'false');
        t.classList.toggle('is-aktiv', an);
        t.tabIndex = an ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !an;
      });
      if (fokus) tab.focus();
      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) {
        var spur = panel.querySelector('.nl-karussell__spur');
        if (spur) spur.scrollLeft = 0;
        aktualisiere(panel);
      }
      window.dispatchEvent(new Event('resize'));
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { waehle(t, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') n = tabs[0];
        else if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); waehle(n, true); }
      });
    });
  }

  /* Punkte unter einem Karussell; blendet die Steuerung aus, wenn nichts zu blättern ist */
  var karussells = [];

  function masse(spur) {
    var kinder = spur.children;
    if (!kinder.length || !spur.clientWidth) return null;
    var breite = kinder[0].getBoundingClientRect().width;
    var luecke = parseFloat(getComputedStyle(spur).columnGap) || 0;
    var schritt = breite + luecke;
    var sichtbar = Math.max(1, Math.floor((spur.clientWidth + luecke + 2) / schritt));
    return { schritt: schritt, stellen: Math.max(1, kinder.length - sichtbar + 1) };
  }

  function aktualisiere(root) {
    var k = root.__nlHome;
    if (!k) return;
    var m = masse(k.spur);
    if (!m) return;
    if (k.steuerung) k.steuerung.hidden = m.stellen < 2;
    if (!k.punkte) return;
    if (k.punkte.childElementCount !== m.stellen) {
      k.punkte.innerHTML = '';
      for (var i = 0; i < m.stellen; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nl-home-punkt';
        b.setAttribute('aria-label', 'Zu Position ' + (i + 1) + ' von ' + m.stellen);
        (function (n) {
          b.addEventListener('click', function () {
            var mm = masse(k.spur);
            if (mm) k.spur.scrollTo({ left: n * mm.schritt, behavior: ruhig() ? 'auto' : 'smooth' });
          });
        })(i);
        k.punkte.appendChild(b);
      }
    }
    var aktiv = Math.min(m.stellen - 1, Math.round(k.spur.scrollLeft / m.schritt));
    if (k.spur.scrollLeft + k.spur.clientWidth >= k.spur.scrollWidth - 2) aktiv = m.stellen - 1;
    Array.prototype.forEach.call(k.punkte.children, function (b, i) {
      if (i === aktiv) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
  }

  function ruhig() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function karussell(root) {
    if (root.__nlHome) return;
    var spur = root.querySelector('.nl-karussell__spur');
    if (!spur) return;
    root.__nlHome = {
      spur: spur,
      punkte: root.querySelector('[data-nl-home-punkte]'),
      steuerung: root.querySelector('[data-nl-home-steuerung]')
    };
    karussells.push(root);
    var wartet = false;
    spur.addEventListener('scroll', function () {
      if (wartet) return;
      wartet = true;
      window.requestAnimationFrame(function () { wartet = false; aktualisiere(root); });
    }, { passive: true });
    aktualisiere(root);
  }

  /* Beaubag: gewähltes Set bestimmt das Ziel des Knopfs */
  function setwahl(root) {
    if (root.dataset.nlHomeBereit) return;
    root.dataset.nlHomeBereit = '1';
    var knopf = root.querySelector('[data-nl-home-set-knopf]');
    Array.prototype.forEach.call(root.querySelectorAll('[data-nl-home-set]'), function (r) {
      r.addEventListener('change', function () {
        if (r.checked && knopf && r.dataset.url) knopf.setAttribute('href', r.dataset.url);
      });
    });
  }

  /* Video im Dialog (erst nach Klick laden) */
  function video(root) {
    if (root.dataset.nlHomeBereit) return;
    root.dataset.nlHomeBereit = '1';
    var dlg = root.querySelector('dialog');
    var vorlage = root.querySelector('template');
    if (!dlg || !vorlage || typeof dlg.showModal !== 'function') return;
    var ziel = dlg.querySelector('[data-nl-home-video-ziel]');
    var ausloeser = null;
    Array.prototype.forEach.call(root.querySelectorAll('[data-nl-home-video-auf]'), function (b) {
      b.addEventListener('click', function () {
        ausloeser = b;
        if (!ziel.firstElementChild) ziel.appendChild(vorlage.content.cloneNode(true));
        dlg.showModal();
        var v = ziel.querySelector('video');
        if (v && v.play) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
    var zu = dlg.querySelector('[data-nl-home-video-zu]');
    if (zu) zu.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () {
      var v = ziel.querySelector('video');
      if (v && v.pause) v.pause();
      if (ausloeser) ausloeser.focus();
    });
  }

  function start(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-nl-home-reiter]'), reiter);
    Array.prototype.forEach.call(s.querySelectorAll('[data-nl-home-karussell]'), karussell);
    Array.prototype.forEach.call(s.querySelectorAll('[data-nl-home-setwahl]'), setwahl);
    Array.prototype.forEach.call(s.querySelectorAll('[data-nl-home-video]'), video);
  }

  var timer = null;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { karussells.forEach(aktualisiere); }, 80);
  });

  window.NlHome = { start: start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); });
  else start(document);
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
